var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tags-view-container",
      attrs: { id: "tags-view-container" },
    },
    [
      _c(
        "scroll-pane",
        {
          ref: "scrollPane",
          staticClass: "tags-view-wrapper",
          on: { scroll: _vm.handleScroll },
        },
        _vm._l(_vm.visitedViews, function (tag) {
          return _c("router-link", {
            key: tag.fullPath,
            ref: "tag",
            refInFor: true,
            staticClass: "tags-view-item",
            class: _vm.isActive(tag) ? "active" : "",
            attrs: {
              to: { path: tag.path, query: tag.query, fullPath: tag.fullPath },
              tag: "span",
            },
            nativeOn: {
              contextmenu: function ($event) {
                $event.preventDefault()
                return _vm.openMenu(tag, $event)
              },
              mouseup: function ($event) {
                if ("button" in $event && $event.button !== 1) {
                  return null
                }
                !_vm.isAffix(tag) ? _vm.closeSelectedTag(tag) : ""
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (ref) {
                    var navigate = ref.navigate
                    return [
                      _c(
                        "span",
                        {
                          on: {
                            click: navigate,
                            keypress: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return navigate.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                (tag.query && tag.query.title) || tag.title
                              ) +
                              " "
                          ),
                          !_vm.isAffix(tag)
                            ? _c("span", {
                                staticClass: "el-icon-close",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.closeSelectedTag(tag)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          })
        }),
        1
      ),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible",
            },
          ],
          staticClass: "contextmenu",
          style: { left: _vm.left + "px", top: _vm.top - 60 + "px" },
        },
        [
          _c(
            "li",
            {
              on: {
                click: function ($event) {
                  return _vm.refreshSelectedTag(_vm.selectedTag)
                },
              },
            },
            [_vm._v("刷新")]
          ),
          _c(
            "li",
            {
              on: {
                click: function ($event) {
                  return _vm.maximize(_vm.selectedTag)
                },
              },
            },
            [_vm._v("最大化")]
          ),
          !_vm.isAffix(_vm.selectedTag)
            ? _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.closeSelectedTag(_vm.selectedTag)
                    },
                  },
                },
                [_vm._v("关闭")]
              )
            : _vm._e(),
          _c("li", { on: { click: _vm.closeOthersTags } }, [
            _vm._v("关闭其它"),
          ]),
          _c(
            "li",
            {
              on: {
                click: function ($event) {
                  return _vm.closeAllTags(_vm.selectedTag)
                },
              },
            },
            [_vm._v("关闭所有")]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }